"use client";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AddBeneficiaryModal({ children }: { children: React.ReactNode }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add New Beneficiary</DialogTitle>
          <DialogDescription>
            Save an account for future quick payouts.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="b-bank">Bank Name</Label>
            <select id="b-bank" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm">
              <option>Select Bank...</option>
              <option>Access Bank</option>
              <option>GTBank</option>
              <option>Zenith Bank</option>
            </select>
          </div>
          <div className="space-y-2">
            <Label htmlFor="b-account">Account Number</Label>
            <Input id="b-account" placeholder="0123456789" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="b-name">Account Name</Label>
            <Input id="b-name" placeholder="John Doe" disabled value="JOHN DOE" className="bg-muted/50" />
          </div>
          <Button className="w-full mt-2">Save Beneficiary</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
